import { render, staticRenderFns } from "./VaultDocumentDetail.vue?vue&type=template&id=f7c4e108&lang=pug"
import script from "./VaultDocumentDetail.vue?vue&type=script&lang=js"
export * from "./VaultDocumentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports